export default "__VITE_ASSET__C0lEY_Sx__"